import { connect } from 'react-redux';
import ConnectableInstanceWidgetStatistic from 'client/components/Instance/components/ConnectableInstanceWidgetStatistic';
import { instanceFstdReadStatistics } from 'client/redux/fstd/statisticsActions';
import _ from 'lodash';

const mapStateToProps =  (state, props) => {
  const id = props.statistic;
  return {
    ...(state.fstd.statistics[id] || {}),
    data: _.get(state, ['fstd', 'statistics', id, 'data', id], null),
  };
};

const actions = {
  readStatistic: instanceFstdReadStatistics,
};

export default connect(mapStateToProps, actions)(ConnectableInstanceWidgetStatistic);
